import UiStorage from '@/composables/useUiStorage/UiStorageService';
import {
  NotificationId,
  NotificationsSeenState
} from '@/modules/notifications/models/NotificationDescriptor';

/**
 * Per-user tracking of which notifications a user has already been shown — backed by the same
 * server-side store the tutorial uses (`UiStorage`, i.e. `users/ui-storage`), but under a distinct
 * key. Maps id → `true` once acknowledged; unseen ids are simply absent.
 */
export class NotificationStorageService {
  public static readonly STORAGE_KEY: string = 'notificationsSeen';
  private storage = UiStorage;

  public async isSeen(id: NotificationId): Promise<boolean> {
    const state = await this.storage.getItem<NotificationsSeenState>(NotificationStorageService.STORAGE_KEY);
    return state?.[id] === true;
  }

  /** Read-modify-write so a single id update never clobbers other ids in the shared blob. */
  public async markSeen(id: NotificationId): Promise<void> {
    const state = (await this.storage.getItem<NotificationsSeenState>(NotificationStorageService.STORAGE_KEY)) ?? {};
    if (state[id] === true) {
      return;
    }
    await this.storage.setItem(NotificationStorageService.STORAGE_KEY, { ...state, [id]: true, });
  }
}
